import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { hideUpdateDialog } from '../../redux/actions/versionState';

const VersionUpdateDialog = () => {
  const dispatch = useDispatch();
  const { showUpdateDialog } = useSelector((state) => state.versionState);

  const handleUpdate = () => {
    // Si el navegador soporta service workers
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistration().then((registration) => {
        // Si hay un service worker en estado de espera
        if (registration?.waiting) {
          registration.waiting.postMessage({ action: "skipWaiting" });
        } else {
          // Caso contrario: Actualizamos la pagina(para obtener el nuevo service worker) y ocultamos el dialogo.
          dispatch(hideUpdateDialog());
          window.location.reload();
        }
        dispatch(hideUpdateDialog());
      });
    }
  };

  return (
    <Dialog open={showUpdateDialog}>
      <DialogTitle>Actualización disponible</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Hay una nueva versión de la aplicación, debe actualizar para continuar.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUpdate} color="primary">
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default VersionUpdateDialog;